<template>
  <div>
    <div
        v-for="(tabBase, tabIndex) in Object.keys(pageTabs)"
        :key="tabIndex"
    >
      <view-analytics-base
          v-if="tabBase === currentTab"
          :currentRoute="pageTabs[tabBase].route"
          :currentTitle="groupingEntitySingle"
          :rowLabel="groupingEntitySingle"
          :subColumnLabel="''"
          :rowTitleLimitIndex="0"
      >
        <template v-slot:baseTitle>
          <div
              v-for="(tab, tabIndex) in Object.keys(pageTabs)"
              :key="tabIndex"
              class="tab-item"
              :class="{'item-disabled' : tab !== currentTab}"
          >
            {{groupingEntityMulti}}
          </div>
        </template>
      </view-analytics-base>
    </div>

  </div>

</template>

<script>
/** пока что вывожу направление через клиентов, позже компоненты могут стать разными */
import ViewAnalyticsBase from './ViewAnalyticsBase';
import schemeClientSlicesTabs from '../../schemes/schemeClientSlicesTabs';
import mixinGroupingEntity from "@/mixins/mixinGroupingEntity";
export default {
  name: 'ViewAnalyticsClients',
  components: {
    ViewAnalyticsBase,
  },
  mixins: [
      mixinGroupingEntity
  ],
  /**
   * данные компонента
   * @property {string} currentRoute - текущий маршрут
   */
  data: () => ({
    currentTab: null,
    pageTabs: schemeClientSlicesTabs,
  }),
  beforeMount() {
    if(this.currentTab === null){
      this.currentTab = 'client';
    }
  }
}
</script>

<style lang="scss" scoped>
  .tab-item {
    display: inline-block;
    padding: 10px;
    //cursor: pointer;
  }

  .item-disabled{
    color: #b0b1b4;
  }
</style>